<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :disableExporting="true"
            :beforeSetupGrid="beforeSetupGrid"
            :actions="actions"
            :selectionEnabled="true"
            ref="grid"
        ></dx-grid>
        <v-dialog v-model="updateStatusDialog" max-width="400">
            <v-card class="pa-2">
                <v-card-title class="headline px-2">Update Status</v-card-title>
                <v-select
                    v-model="noteStatus"
                    label="Status"
                    class="px-2 mx-1"
                    :items="statuses"
                ></v-select>
                <v-card-actions class="mr-2 pr-1">
                    <v-spacer></v-spacer>
                    <v-btn
                        dark
                        color="default"
                        @click="updateStatusDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        dark
                        color="success"
                        @click="saveStatus"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    data: () => ({
        title: "Notes",
        matchDialog: false,
        deleteMatchDialog: false,
        addMatchDialog: false,
        infoDialog: false,
        matchInfoDialog: false,
        existingMatchesWarningDialog: false,
        clickedPerson: {},
        clickedDOE: {},
        clickedMatchDoe: {},
        selectedMatches: [],
        matches: [],
        userID: "",
        processing: false,
        showDoeGrid: false,
        url: "",
        actions: [],
        phoneSearch: "",

        noteStatus: "",
        selected: [],
        updateStatusDialog: false,
        statuses: ["Open", "Closed"],

        columns: [
            {
                field: "titleHebrew",
                label: "Title Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstHebrew",
                label: "First Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastHebrew",
                label: "Last Hebrew",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "firstEnglish",
                label: "First English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastEnglish",
                label: "Last English",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "accountID",
                label: "Person ID",
                //link: "DinnerAccountView",
                format: "",
                //template: "link-cell-template",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "date",
                label: "Date",
                type: "date",
                format: "",
                visible: true,
                filterType: "",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "byUser",
                label: "User",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "note",
                label: "Note",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "followUpDate",
                label: "Follow Up Date",
                format: "",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "status",
                label: "Status",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "communicationType",
                label: "Communication Type",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "lastUpdated",
                label: "Last Updated",
                format: "",
                visible: true,
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "address1",
                label: "Address",
                format: "",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "city",
                label: "City",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "state",
                label: "State",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "zip",
                label: "Zip",
                format: "",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "matchCount",
                label: "Match Count",
                type: "number",
                visible: true,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                field: "phone",
                label: "Phone",
                visible: false,
                filterType: "",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {
        beforeSetupGrid() {
            this.actions.push({
                text: "Update Status",
                action: this.openUpdateStatusDialog,
                showOnSelection: true,
            });

            this.url = "votingRegistrationNotes";
        },
        openUpdateStatusDialog() {
            this.selected = this.$refs.grid.getSelectedRowsData();
            this.updateStatusDialog = true;
        },
        async saveStatus() {
            if (!this.noteStatus) {
                return this.$notify({
                    text: "Please Select Status",
                    group: "notification",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/note/updateNoteStatus", {
                    user: this.$store.state.authentication.user,
                    status: this.noteStatus,
                    ids: this.selected.map((s) => s.id),
                });

                this.noteStatus = "";
                this.updateStatusDialog = false;

                this.$notify({
                    text: "Changes Saved",
                    group: "notification",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();
                this.processing = false;
            } catch (e) {
                this.processing = false;
            }
        },
        // async loadUserID() {
        //     this.userID = await this.$http.get(
        //         "api/users/getUserID?username=" +
        //             this.$store.state.authentication.user
        //     );
        // },
    },
};
</script>
<style></style>
